import React, { Component } from 'react';
import { connect } from 'react-redux';
import history from '../../app/history';
import { clearAllTokens } from './keycloakUtils';
import { purgeAccountData } from '../../redux/actions/accountActions';
import Loading from '../../custom/Loading';

class LogoutSuccess extends Component {
  componentDidMount() {
    this.handleLogoutCleanup();
  }

  handleLogoutCleanup = () => {
    try {
      history.push('/login');
    } catch (error) {
      history.push('/login');
    }
  };

  render() {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh'
        }}
      >
        <Loading center />
        <p style={{ marginTop: '20px', color: '#666' }}>Cerrando sesión...</p>
      </div>
    );
  }
}

export default connect(null, {
  purgeAccountData
})(LogoutSuccess);



// WEBPACK FOOTER //
// ./src/components/auth/LogoutSuccess.js